import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnDestroy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { ContainerComponent } from '../container/container.component';
import { PictureComponent } from '../picture/picture.component';
import { Subscription } from 'rxjs';
import { NavigationService } from '../../services/navigation.service';
import { GlobalModalService } from '../../services/global-modal.service';
import { HelpersService } from '../../services/helpers.service';

@Component({
  selector: 'footer',
  imports: [CommonModule, ContainerComponent, PictureComponent],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  host: {
    class: 'bg-gray-800 text-white'
  }
})
export class FooterComponent implements OnDestroy {

  helpersService = inject(HelpersService)

  modalService = inject(GlobalModalService);

  navigationService = inject(NavigationService);

  sanitize = inject(DomSanitizer)

  @Input() code?: string;
  @Input() date?: string;
  @Input() year?: string;

  defaultDate: string = '03/2025';

  defaultYear: string = '2026';

  currentLinkSub!: Subscription;

  isSpanishPage: boolean = false;

  socialLinks = [
    {
      name: 'Instagram',
      icon: 'instagram.svg',
      alttag: 'Instagram Logo',
      alttagEs: 'Logotipo de Instagram',
      link: 'https://www.instagram.com/screenfortype1/'
    },
    {
      name: 'Facebook',
      icon: 'facebook.svg',
      alttag: 'Facebook Logo',
      alttagEs: 'Logotipo de Facebook',
      link: 'https://www.facebook.com/screenfortype1'
    },
    {
      name: 'YouTube',
      icon: 'youtube.svg',
      alttag: 'YouTube Logo',
      alttagEs: 'Logotipo de YouTube',
      link: 'https://www.youtube.com/@screenfortype1'
    }
  ]

  links = [
    {
      name: 'Legal Disclaimer',
      link: 'https://www.sanofi.us/en/legal-notice'
    },
    {
      name: 'Privacy Policy',
      link: 'https://www.sanofi.com/en/sanofi-us-privacy-policies'
    },
    {
      name: 'Consumer Health Data Privacy Policy',
      link: 'https://www.sanofi.us/en/consumer-health-data-privacy-policy'
    },
    {
      name: 'Cookie Policy',
      link: 'https://www.sanofi.com/en/data-privacy'
    },
    {
      name: 'Contact SANOFI',
      link: 'https://www.sanofi.us/en/contact-us'
    },
    {
      name: 'Site Map',
      link: '/site-map/'
    }
  ]

  spanishLinks = [
    {
      name: 'Aviso legal',
      link: 'https://www.sanofi.us/en/legal-notice'
    },
    {
      name: 'Política de privacidad',
      link: 'https://www.sanofi.com/en/sanofi-us-privacy-policies'
    },
    {
      name: 'Política de privacidad de datos de salud del consumidor',
      link: 'https://www.sanofi.us/en/consumer-health-data-privacy-policy'
    },
    {
      name: 'Política sobre el uso de cookies',
      link: 'https://www.sanofi.com/en/data-privacy'
    },
    {
      name: 'Comuníquese con SANOFI',
      link: 'https://www.sanofi.us/en/contact-us'
    },
    {
      name: 'Mapa del sitio',
      link: '/site-map'
    }
  ]

  constructor() {
    this.currentLinkSub = this.navigationService
      .getCurrentUrl()
      .subscribe((url) => {
        this.isSpanishPage = url === '/es' || url.startsWith('/es/');
      });
  }

  onCookieModal(): void {
    //validate platform
    if (!this.helpersService.validatePlatform()) return;

    //add action to cookie modal to hide backdrop
    const cookieModalBtn = this.helpersService.doc.getElementById('close-pc-btn-handler');
    cookieModalBtn?.addEventListener('click', () => {
      setTimeout(() => {
        const cookieModalBackdrop = this.helpersService.doc.querySelector('.onetrust-pc-dark-filter') as HTMLElement;
        cookieModalBackdrop.style.display = 'none';
      }, 500);
    })
  }

  ngOnDestroy(): void {
    this.currentLinkSub.unsubscribe();
  }

  onClick(url: string, e: Event) {
    e.preventDefault();
    this.modalService.openModal('interstitial', url)
  }

}
